module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "",
      "center": true,
      "visible": _vm.particularsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.particularsVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "particulars-view"
  }, [_c('div', {
    staticClass: "descriptions-title-view"
  }, [_vm._v("\n      视频信息详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-view"
  }, [_c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("发布人:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.handleTypeByValue(_vm.particularsData.platformUserId, _vm.platformUserOptions)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("视频标题:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.videoTitle) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("视频简介:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.videoText) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("封面图片:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.handleImageUrl(_vm.particularsData.faceUrl)
    },
    on: {
      "click": function($event) {
        _vm.handlePreView(_vm.handleImageUrl(_vm.particularsData.faceUrl))
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("访问地址:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.handlePreviewVideo(_vm.particularsData)
      }
    }
  }, [_vm._v("点击预览")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("点赞数:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.tagNum) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("平均评分:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.starNum) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("视频状态:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.handleTypeByValue(_vm.particularsData.videoStatus, _vm.videoStatusOption)) + "\n          ")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.previewVideoVisible,
      "append-to-body": "",
      "title": "视频预览"
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVideoVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "video-item"
  }, [_c('vueMiniPlayer', {
    ref: "vueMiniPlayer",
    attrs: {
      "video": _vm.videoItem,
      "mutex": true
    },
    on: {
      "fullscreen": _vm.handleFullscreen
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "visible": _vm.previewVisible,
      "title": "图片预览"
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.previewImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5364b32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5364b32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/videoData/ItemParticulars.vue
// module id = 1326
// module chunks = 1